import { render } from "./ServicePageEditor.vue?vue&type=template&id=97647176&scoped=true"
import script from "./ServicePageEditor.vue?vue&type=script&lang=js"
export * from "./ServicePageEditor.vue?vue&type=script&lang=js"

import "./ServicePageEditor.vue?vue&type=style&index=0&id=97647176&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97647176"]])

export default __exports__